export function generateSouthAfricanMSISDN() {
  // Common South African mobile prefixes
  const prefixes = [
    "60", "61", "62", "63", "64",
    "65", "66", "67", "68", "71",
    "72", "73", "74", "76", "78", "79", "81", "82", "83", "84"
  ];

  // Pick a random prefix
  const prefix = prefixes[Math.floor(Math.random() * prefixes.length)];

  // Generate the remaining 7 digits
  const rest = Math.floor(Math.random() * 10000000).toString().padStart(7, "0");

  // Return full MSISDN in E.164 format
  return `27${prefix}${rest}`;
}